export default Object.freeze({
  comma: function(num) {
    let len, point, str;

    num = num + "";
    point = num.length % 3;
    len = num.length;

    str = num.substring(0, point);
    while (point < len) {
      if (str != "") str += ",";
      str += num.substring(point, point + 3);
      point += 3;
    }

    return str;
  },
  dateTypeFromat: function(date) {
    return date.replace(/\./gi, "-");
  },
  onlyNumber: function(number) {
    if (typeof number == "number") {
      return number;
    }
    let result = number.replace(/[^0-9]/g, "");
    return Number(result);
  },
  sendTimeSplit: function(parma) {
    let time = parma.split(":");
    return time;
  },
  pointSubscriptionConversion: (value) => {
    let str = "";
    if (value) {
      let date = value.split(" ");
      str = `${date[0]}일 ${date[1]}`;
    }

    return `${str}`;
  },
});
